<template>
	<div class="container">
		<router-link
			class="trendMap"
			:to="{ name: 'Trendmap', query: { id: $route.query.id, index: $route.query.index } }"
			target="_blank"
			><span>开奖走势</span>
		</router-link>
		<div class="favorite-lottery">
			<a v-if="!isFavorite" type="text" class="btn-favorite" @click="addUserFavoritesLottery(LgId)">
				<img src="@/static/img/icon/star-unselected.webp" alt="添加收藏" /><span>添加收藏</span>
			</a>
			<a v-if="isFavorite" type="text" class="btn-favorite" @click="deleteUserFavoritesLottery(LgId)">
				<img src="@/static/img/icon/star-selected.webp" alt="取消收藏" /><span>取消收藏</span>
			</a>
		</div>
		<div class="toOpenLink" @click="toOpenLink()">
			<span>开奖网</span>
		</div>
	</div>
</template>

<script>
import { game } from "@/mixins/game";

export default {
	mixins: [game],
	name: "favorite",
	props: {
		LgId: {
			type: Number,
			required: true,
		},
		GameName: {
			type: String,
		},
	},
	data() {
		return {
			configInfo: window.systemData,
		};
	},
	computed: {
		userFavoritesLotteryList() {
			return this.$store.state.userFavoritesLotteryList; // 用户收藏彩种集合
		},
		isFavorite() {
			return this.$store.state.userFavoritesLotteryList.some(item => item.LgId === this.LgId);
		},
	},
	methods: {
		toOpenLink() {
			window.open(`${this.configInfo.OpenAddress.SysValue}/#/often?code=${this.LgId}&name=${this.GameName}`);
		},
	},
};
</script>

<style lang="less" scoped>
.container {
	position: absolute;
	top: 12px;
	right: 15px;
	width: 86px;

	.trendMap {
		display: flex;
		align-items: center;
		justify-content: flex-start;
		padding-left: 5px;
		box-shadow: 0px 1px 3px 0 rgba(0, 0, 0, 0.45);
		border: solid 1px #edf0fa;
		background-image: linear-gradient(to top, #edf0fa, #fff);
		border-radius: 3px 3px 3px 3px;
		height: 30px;
		&::before {
			content: "";
			background-image: url("~@/static/img/icon/trendMap-icon.webp");
			background-size: cover;
			width: 16px;
			height: 16px;
		}
	}
	.favorite-lottery {
		display: flex;
		align-items: center;
		justify-content: center;
		margin-top: 5px;
		box-shadow: 0px 1px 3px 0 rgba(0, 0, 0, 0.45);
		border: solid 1px #edf0fa;
		background-image: linear-gradient(to top, #edf0fa, #fff);
		border-radius: 3px 3px 3px 3px;
		height: 30px;
		a {
			display: flex;
			align-items: center;
			justify-content: flex-start;
			padding-left: 5px;
			width: 100%;
		}
		i {
			font-size: 16px;
		}
		img {
			width: 16px;
			height: 16px;
		}
	}
	.toOpenLink {
		display: flex;
		align-items: center;
		justify-content: flex-start;
		padding-left: 5px;
		margin-top: 5px;
		box-shadow: 0px 1px 3px 0 rgba(0, 0, 0, 0.45);
		border: solid 1px #edf0fa;
		background-image: linear-gradient(to top, #edf0fa, #fff);
		border-radius: 3px 3px 3px 3px;
		height: 30px;
		cursor: pointer;
		&::before {
			content: "";
			background-image: url("~@/static/img/icon/Vector.webp");
			background-size: cover;
			width: 16px;
			height: 16px;
		}
	}
	span {
		width: 28px;
		margin-left: 5px;
		font-family: PingFangSC;
		font-weight: normal;
		line-height: 1.1;
		color: #888;
		font-size: 13px;
		white-space: nowrap;
	}
}
</style>



// WEBPACK FOOTER //
// src/components/common/favorite.vue